module.exports = __webpack_public_path__ + "static/media/12-iveco.32140ef5.jpg";